import { api } from '../../../utils/client';
import type { AdminSubtabRow, AdminTabRow, PlatformSettingRow } from './types';

function asList<T>(data: T[] | { results?: T[] }): T[] {
  return Array.isArray(data) ? data : data?.results ?? [];
}

export async function fetchPlatformSettings() {
  const data = await api<PlatformSettingRow[] | { results: PlatformSettingRow[] }>(
    '/api/admin/platform-settings/'
  );
  return asList(data);
}

export async function updatePlatformSetting(id: number, value: string) {
  return api<PlatformSettingRow>(`/api/admin/platform-settings/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({ value }),
  });
}

export async function fetchAllAdminTabs() {
  const data = await api<AdminTabRow[] | { results: AdminTabRow[] }>(
    '/api/admin/tabs/?all=1'
  );
  return asList(data);
}

export async function reorderAdminTabs(
  items: Array<{
    id: number;
    display_order: number;
    label: string;
    is_visible: boolean;
  }>
) {
  return api<AdminTabRow[]>('/api/admin/tabs/reorder/', {
    method: 'PATCH',
    body: JSON.stringify(items),
  });
}

export async function fetchAllAdminSubtabs() {
  const data = await api<AdminSubtabRow[] | { results: AdminSubtabRow[] }>(
    '/api/admin/subtabs/?all=1'
  );
  return asList(data);
}

export async function reorderAdminSubtabs(
  items: Array<{
    id: number;
    display_order: number;
    label: string;
    is_visible: boolean;
  }>
) {
  return api<AdminSubtabRow[]>('/api/admin/subtabs/reorder/', {
    method: 'PATCH',
    body: JSON.stringify(items),
  });
}
